import React, { useState } from "react";
import {
  Button,
  Modal,
  ActionIcon,
  Text,
  Flex,
  Badge,
  Stack,
  Box,
} from "@mantine/core";
import {
  IconStarFilled,
  IconCaretDown,
  IconCaretRight,
} from "@tabler/icons-react";

import StarDisplay from "../Matrix/StarDisplay";

export default function QuestionItem({
  title,
  dimension,
  factor,
  departments,
}) {
  const [isOpen, setOpen] = useState(false);

  const topDepts = [...departments]
    .sort((a, b) => b.response_rating - a.response_rating)
    .slice(0, 3);
  const bottomDepts = [...departments]
    .sort((a, b) => a.response_rating - b.response_rating)
    .slice(0, 3);

  return (
    <div className="question-dept-list-item">
      <div className="meta">
        <Flex align="flex-start" gap="md">
          {departments.length > 0 && (
            <ActionIcon
              variant="light"
              size="lg"
              onClick={() => setOpen(!isOpen)}
              radius="xl"
            >
              {isOpen ? <IconCaretDown size={24} /> : <IconCaretRight />}
            </ActionIcon>
          )}
          <div style={{ flexGrow: 1 }}>
            <Stack gap="xs">
              <Text size="lg" fw={600}>
                {title}
              </Text>
              <Flex align="center" gap="xs">
                <Badge color="blue" variant="light">
                  {dimension}
                </Badge>
                <Badge color="blue" variant="light">
                  {factor}
                </Badge>
              </Flex>
            </Stack>
          </div>
        </Flex>
        <div className="meta-bottom">
          {departments.length > 0 && (
            <Flex gap="xl" mt="lg">
              <Viz
                title="Top Raters"
                names={topDepts.map((t) => ({
                  id: t.id,
                  text: t.text,
                  value: Math.round((t.response_rating / 20) * 100) / 100,
                  comments: t.answers
                    .filter((f) => f.comment)
                    .map((m) => m.comment),
                }))}
                positive
              />
              <Viz
                title="Lowest Raters"
                names={bottomDepts.map((t) => ({
                  id: t.id,
                  text: t.text,
                  value: Math.round((t.response_rating / 20) * 100) / 100,
                  comments: t.answers
                    .filter((f) => f.comment)
                    .map((m) => m.comment),
                }))}
              />
            </Flex>
          )}
          {departments.length === 0 && <p>No department data</p>}
        </div>
      </div>
      {isOpen && <QuestionContent departments={departments} />}
    </div>
  );
}

QuestionItem.defaultProps = {
  departments: [],
  dimension: "",
  factor: "",
  title: "",
};

const Viz = ({ names, title, positive }) => {
  return (
    <div className="meta-viz">
      <Text size="md" fw={600} mb="xs">
        {title}
      </Text>
      <ul className={positive ? "positive" : ""}>
        {names.map((n) => (
          <VizItem
            key={n.id}
            text={n.text}
            value={n.value}
            comments={n.comments}
          />
        ))}
      </ul>
    </div>
  );
};

Viz.defaultProps = {
  title: [],
  names: [],
  positive: false,
};

const VizItem = ({ text, value, comments }) => {
  const [isOpen, setOpen] = useState(false);

  function onClose() {
    setOpen(false);
  }

  return (
    <React.Fragment>
      <Modal opened={isOpen} onClose={onClose} size="md" title={text}>
        {comments.map((c, i) => (
          <Text key={i}>{c}</Text>
        ))}
        {comments.length === 0 && <Text size="sm">No comments</Text>}
      </Modal>
      <li
        onClick={() => {
          setOpen(true);
        }}
      >
        <span className="text">{text}</span>
        <span className="value">
          <IconStarFilled size={16} style={{ marginRight: "3px" }} /> {value}
        </span>
      </li>
    </React.Fragment>
  );
};

VizItem.defaultProps = {
  text: "",
  value: "",
  comments: [],
};

const QuestionContent = ({ departments }) => {
  return (
    <div className="content">
      <h4>All raters for this question</h4>
      {departments
        .sort((a, b) => b.response_rating - a.response_rating)
        .map((d) => (
          <div key={d.id} className="dept">
            <h5>{d.text}</h5>
            <StarDisplay value={d.response_rating} />
          </div>
        ))}
    </div>
  );
};
